import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Csloping(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free JavaScript Looping Statement Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Looping Statement tutorial for beginners.Looping Statement in Javascript is used to repeat a particular piece of cards until the given condition is false" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Javascript Looping Statement,Javascript Looping Statement for loop,end for loop Javascript,Javascript looping Statement Types,javascript looping statements example,javascript for loop return statement" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-looping-statement" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript Looping Statement</h1>
    <div className="first">
        <a href="/javascript-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">A looping statement in Javascript uses to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are three types of looping statements in Javascript programming:
</h2>
<h3 className="mt-4 mh3">1, using a while loop in Javascript statement<br/>
2, using  a do-while looping in Javascript statement<br/>
3, using a for looping in Javascript <br/>

</h3>
<h2 className="mt-4 mh2">1, while loop in Javascript:</h2>
<p className="mt-4 para">In a while, will give the loop Javascript condition, and the loop's body executes until the state is false.
</p>
<h3 className="mt-4 mh2">While loop syntax in Javascript</h3>


        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            {"\n"}
      <span className="qwerty-8">while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
    
      {"\n"}
      <span className="qwerty-10">&nbsp;statement</span>
          {"\n"}
      <span className="qwerty-3">&#125; </span>
    
    {"\n"}  {"\n"}
         </code>
          </pre>        
        </div>


<h2 className="mt-4 mh2">2,Do-while loop in JavaScript:</h2>
<p className="mt-4 para">In the do-while loop, a condition will be given and check after executing the loop's body.
</p>

    
<h2 className="headings">Do-while loop Javascript syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-8">do</span>
        {"\n"}
        <span className="qwerty-3">&#123; </span>

  {"\n"}
  <span className="qwerty-10">&nbsp;statement</span>
  {"\n"}
  <span className="qwerty-10">&nbsp;statement</span>
  {"\n"}
  <span className="qwerty-3">&#125; </span>
  {"\n"}
  <span className="qwerty-8">while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">condition</span> 
  <span className="qwerty-1">);</span>
  {"\n"}
  
{"\n"}
    </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">3, for loop Javascript:</h2>
<p className="mt-4 para">1, In the for loop Javascript, the body of the loop will be executed until the given condition is false<br/>
2, This for loop uses to repeat a particular piece of code for a fixed no of times<br/>
3, In the for loop Javascript(Javascript), two semicolons must use<br/>
</p>


<h2 className="headings">For loop Javascript Syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
      
      {"\n"}
  <span className="qwerty-10">for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">statement;</span>
  <span className="qwerty-6">condition;</span>
  <span className="qwerty-3">statement</span>
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;Statement ;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#125; </span>
  {"\n"}  {"\n"}
 </code>
      </pre>        
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csloping;